import { render, staticRenderFns } from "./PhoneCard.vue?vue&type=template&id=118722bf&scoped=true&"
import script from "./PhoneCard.vue?vue&type=script&lang=js&"
export * from "./PhoneCard.vue?vue&type=script&lang=js&"
import style0 from "./PhoneCard.vue?vue&type=style&index=0&id=118722bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118722bf",
  null
  
)

export default component.exports